import { useEffect } from "react";
import { api } from "../api";

// Tracks a page view on mount (fire and forget)
export default function VisitTracker() {
  useEffect(() => {
    const KEY = "em_visit_ts";
    const last = Number(localStorage.getItem(KEY) || 0);
    const now = Date.now();
    if (now - last < 30 * 60 * 1000) return; // throttle: 1 view / 30 min / device
    localStorage.setItem(KEY, String(now));
    api.post("/visits", { path: window.location.pathname, referrer: document.referrer || null }).catch(() => {});
  }, []);
  return null;
}
